import React, { useContext, useMemo, useRef, useState } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import { ThemeProvider } from '@front10/base-elements';
import { EmotionCache } from '../../containers/_commons/emotionCache';
/**
 * Atoms
 */
import { Listbox } from '../../lab/Listbox';
import { FilterButton } from '../../lab/FilterButton';
import { Panels } from '../../containers/VerticalBookingContainer/Panels';
import { FlexibleFilterContainer } from '../../lab/FlexibleFilterContainer';
/**
 * Hooks
 */

const TravelClassFilter = (props, ref) => {
  const {
    options = [
      { label: 'cmp-travel-class--economy', value: 'ECONOMY' },
      { label: 'cmp-travel-class--business', value: 'BUSINESS' }
    ],
    value,
    labelKey = 'cmp-travel-class-label',
    defaultValue,
    disabled,
    onChange,
    filterButtonIconProps,
    containerSettings = {
      showSeparator: true,
      enabledDoneButton: true,
      isMobile: false
    },
    showDescriptionLabel = false,
    disabledActiveFilterButtonValue = undefined
  } = props;

  const {
    translate,
    direction,
    theme: { designTokens }
  } = useContext(Context);

  const TravelClassRef = useRef(null);
  const [travelClassFilter, setTravelClass] = useState(value[0]);

  React.useEffect(() => {
    setTravelClass(value[0]);
  }, [value]);

  const title = translate('cmp-travel-class-title', 'Travel Class');
  const travelClassOptions = useMemo(() => {
    return (Array.isArray(options) ? options : []).map((option) => ({
      ...option,
      label: translate(option.label)
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [translate, options]);

  const valueTranslated = useMemo(() => {
    return options
      .filter((option) => option.value === value[0])
      .map((option) => {
        return translate(option.label);
      })
      .pop();
  }, [options, translate, value]);

  const listboxRef = useRef(null);

  React.useImperativeHandle(
    ref,
    () => ({
      focusToggleElement: () => {
        listboxRef.current.focusToggleElement();
      }
    }),
    []
  );

  const desktopLayout = (
    <Listbox
      filterButtonIconProps={filterButtonIconProps}
      activeFilterButton={
        disabledActiveFilterButtonValue ? disabledActiveFilterButtonValue !== value[0] : undefined
      }
      ref={listboxRef}
      label={translate(labelKey, 'Select Travel Class')}
      placeholder={title}
      options={travelClassOptions}
      defaultValue={defaultValue}
      forcePlaceholder={disabled}
      disabled={disabled}
      onChange={(value) => onChange({ value })}
      focusWhenIsShow={false}
      prefixSelectedItem={
        showDescriptionLabel
          ? translate('cmp-travel-class-filter-prefix-selected-item', 'Travel Class')
          : null
      }
    />
  );

  const mobileLayout = (
    <FlexibleFilterContainer
      {...containerSettings}
      onDismiss={() => {
        setTravelClass(value[0]);
      }}
      mobileView={containerSettings.isMobile}
      saveOnClose={false}
      variant="layout.popover"
      label={title}
      title={title}
      enabledClearButton={false}
      disabledDoneButton={false}
      disabledClearButton={true}
      labelBottomBtn={translate('cmp-travel-class-done-button', 'Done')}
      labelClearBtn={translate('cmp-travel-class-clear-button', 'Clear')}
      toggleElement={
        <FilterButton
          iconSettings={filterButtonIconProps}
          value={
            value && !disabled
              ? `${
                  showDescriptionLabel
                    ? translate('cmp-travel-class-filter-prefix-selected-item', 'Travel Class')
                    : ''
                } ${valueTranslated} `
              : title
          }
          aria-label={`${title} ${value ? valueTranslated : ''}`}
          active={
            disabledActiveFilterButtonValue
              ? disabledActiveFilterButtonValue !== value[0]
              : Boolean(value)
          }
          disabled={disabled} // used to disabled the component
        />
      }
      onSave={() => {
        props.onChange({ value: travelClassFilter });
      }}
    >
      <Panels showSeparator={false}>
        {options.length > 0 && (
          <Listbox
            ref={TravelClassRef}
            label={translate('cmp-travel-class-placeholder', 'Select Travel Class')}
            layout="standard"
            options={travelClassOptions}
            key={Math.floor(Math.random() * 100 + 1)} // ???
            defaultValue={travelClassFilter}
            onChange={(newFlightType) => {
              setTravelClass(newFlightType);
            }}
            // prefixSelectedItem={
            //   showDescriptionLabel
            //     ? translate('cmp-travel-class-filter-prefix-selected-item', 'Travel Class')
            //     : null
            // }
          />
        )}
      </Panels>
    </FlexibleFilterContainer>
  );

  return (
    <EmotionCache direction={direction}>
      <ThemeProvider theme={designTokens}>
        {!containerSettings.isMobile ? desktopLayout : mobileLayout}
      </ThemeProvider>
    </EmotionCache>
  );
};

export default React.forwardRef(TravelClassFilter);
